module.exports = __webpack_public_path__ + "static/media/shape_green-illustration.e1d62e23.svg";